(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-location"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const addressEl = document.getElementById('change-location-btn');
    if (!addressEl) return;

    const address = localStorage.getItem('userAddress');
    if (address) {
      addressEl.textContent = address;
    }
  });
  } catch(e) { console.error(e); }
})();

})();
